import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0AvatarTeam } from '@factorialco/f0-react'
import {
  ProjectionKind,
  useExpensablesByCategoryTotals,
} from 'generated/resources/datatable.graphql'
import { ExpensesExpensableFiltersInput } from 'generated/resources/graphql'

import DataTable from 'modules/core/components/DataTable'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import { usePageDateFilters } from 'modules/expenses/lib/PageDateFiltersContext'

import Money from 'modules/expenses/pages/ExpensesReportsPage/Money'

interface ExpensablesByCategoryDatatableProps {
  filters: ExpensesExpensableFiltersInput
}

const ExpensablesByCategoryDatatable = ({ filters }: ExpensablesByCategoryDatatableProps) => {
  const { company } = useCurrentSession()
  const { dateFilters } = usePageDateFilters()
  const { currency } = filters

  const source = useExpensablesByCategoryTotals(
    [
      {
        identifier: 'customCategory.label',
        title: i18n.t('expenses_v2.reports.expenses_by_category.columns.category'),
        kind: ProjectionKind.Custom,
        template: '{{ customCategory.label }}',
        render: ({ customCategory }) => {
          return (
            <Box flexDirection="row" alignItems="center" gap="s8">
              <F0AvatarTeam name={customCategory.label} size="md" />
              <Text.Normal size="200" weight="medium" ellipsis>
                {customCategory.label}
              </Text.Normal>
            </Box>
          )
        },
      },
      {
        identifier: 'totalAmount',
        title: i18n.t('expenses_v2.reports.expenses_by_category.columns.amount'),
        kind: ProjectionKind.Custom,
        template: '{{ totalAmount }}',
        render: ({ totalAmount }) => {
          return <Money amount={totalAmount} currency={currency} />
        },
        sortBy: 'totalAmount',
      },
    ],
    {
      variables: {
        companyId: company.id,
        from: dateFilters.startDate.toISOString(),
        to: dateFilters.endDate.toISOString(),
        filters: { ...filters },
      },
    }
  )

  return (
    <Box height="s400" maxHeight="s400" overflowY="auto">
      <DataTable
        disableExport
        source={source}
        pagination={{ kind: 'offset', itemsPerPage: 50, infiniteScroll: true }}
        disableEditColumns
        sort={{ path: 'totalAmount', direction: 'desc' }}
      />
    </Box>
  )
}

export default ExpensablesByCategoryDatatable
